import { Flex, Spin } from 'antd'
import { t } from 'i18next'
import React from 'react'
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/react/timegrid'
import interactionPlugin from '@fullcalendar/react/interaction'
import classicTheme from '@fullcalendar/react/themes/classic'
import frLocale from '@fullcalendar/react/locales/fr'
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import localeData from 'dayjs/plugin/localeData'
import AvailableNowCard from '../AvailableNowCard'
import CreateEventCard from '../../EventsPage/CreateEventCard'
import CustModal from '../../../Common/CustModal'
import AppointmentCreationForm from '../../AppointmentsPage/AppointmentCreationForm'

dayjs.extend(weekday)
dayjs.extend(localeData)

export default function BoxCalendarPageXL ({
  box, appointmentModalVisible, loading, appointmentForm, setAppointmentModalVisible,
  onAdd, rangeDisable, boxAvailableNow, setRangeDisable,
  loadCalendarData, day, events, renderEventContent, selected, minHour, maxHour, okButtonProps
}) {
  return (
    <>
      {box && <>
        <CustModal
          open={appointmentModalVisible}
          setOpen={setAppointmentModalVisible}
          title={t('Admin.BoxCalendar.popupTitle')}
          confirmLoading={loading}
          mask={{ closable: true }}
          onOk={appointmentForm.submit}
          okButtonProps={okButtonProps}
        >
          <Spin spinning={loading}>
            <AppointmentCreationForm form={appointmentForm} onFinish={onAdd} rangeDisable={rangeDisable} />
          </Spin>
        </CustModal>
        <Flex vertical style={{ padding: '1em', backgroundColor: 'white' }}>
          <Flex>
            {
              boxAvailableNow && <AvailableNowCard setModalVisible={setAppointmentModalVisible} setRangeDisable={setRangeDisable} form={appointmentForm} appointmentDuration={box.appointment_duration} />
            }
            <CreateEventCard box={box} />
          </Flex>
          <FullCalendar
            height="auto"
            selectable={true}
            plugins={[timeGridPlugin, interactionPlugin, classicTheme]}
            headerToolbar={{ start: 'title', end: 'today prev,next' }}
            initialDate={day || dayjs().format('YYYY-MM-DD')}
            initialView="timeGridWeek"
            firstDay={dayjs().day() - 1}
            slotDuration="00:30:00"
            dayHeaderClass={'colored-header'}
            locale={frLocale}
            allDaySlot={false}
            displayEventTime={false}
            events={events}
            eventContent={renderEventContent}
            datesSet={loadCalendarData}
            select={(info) => selected(info)}
            eventOrder={'type'}
            slotMinTime={minHour + ':00:00'}
            slotMaxTime={maxHour + ':00:00'}
            nowIndicator={true}
          />
        </Flex>
      </>
      }
    </>
  )
}
